<template>
  <div class="footer-tabbar">
    <div class="tabbar-item" :class="{'tabbar-item-active':active===item.value}" v-for="(item,index) in list" :key="index"
      @click="itemClick(item)">
      {{item.label}}</div>
  </div>
</template>
<script>
export default {
  name: 'footer-tabbar',
  data () {
    return {
      list: [
        {
          label: '全部商品',
          value: 'all'
        },
        {
          label: '自选',
          value: 'optional'
        }
      ],
      active: 'all'
    }
  },
  methods: {
    itemClick (item) {
      this.active = item.value
      this.$emit('itemClick', item.value)
    }
  },
}
</script>
<style lang="scss" scoped>
.footer-tabbar {
  width: 100%;
  height: 28px;
  line-height: 28px;
  background: #1d212e;
  display: flex;
  .tabbar-item {
    text-align: center;
    width: 120px;
    font-size: 13px;
    border-right: 1px solid #ddd;
    cursor: pointer;
  }
  .tabbar-item-active {
    background-color: #27498e;
    color: #ffffff;
  }
}
</style>